exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{min-height:calc(100vh - 36px);width:100%;position:relative;overflow:hidden}.fixed-header+.app-main[data-v-078753dd]{padding-top:50px}.hasTagsView .app-main[data-v-078753dd]{background:#f5f5f5;min-height:calc(100vh - 36px)}.hasTagsView .fixed-header+.app-main[data-v-078753dd]{padding-top:80px}.el-popup-parent--hidden .fixed-header[data-v-078753dd]{padding-right:15px}", ""]);

// exports
